import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import '../scss/table.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moFreshCity from './store';
import PDF from '../../../component/pdf';
import Title from '../../../component/title';
import HeadPdf from '../../../component/head-pdf';
import FootPdf from '../../../component/foot-pdf';
import moIndex from '../../../store/index';
import TablePDF from '../../indicator-table';
import FreshTable from '../../fresh-table';
import Explain from './explain';

interface IProps {}
interface IState {}

const Table = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const { tableHead, tableList } = moFreshCity;

  useEffect(() => {
    // console.log('table right -- ', toJS(tableRight));

    return () => {};
  }, []);

  return (
    <FreshTable tableHead={tableHead} tableList={tableList} />
  );
};

export default observer(Table);
